import {SkillsI18n} from '@/locales/base.message.locales';

export const skills: SkillsI18n = {
  titles: {
    skills: 'Habilidades',
    my_skills: 'Minhas Habilidades',
    subtitle: 'Selecione suas habilidades abaixo',
  },
};
